export default __webpack_public_path__ + "static/okr-progress-53426d6e8cc14d416e84d30ab48e8fec.mp4";